import React, { useState, useEffect } from 'react';

export default function Gallery({ items = [] }) {
  const [active, setActive] = useState(null);
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    function onKey(e) {
      if (!active) return;
      if (e.key === 'Escape') setActive(null);
      if (e.key === 'ArrowRight') setActiveIdx((i) => Math.min(i + 1, items.length - 1));
      if (e.key === 'ArrowLeft') setActiveIdx((i) => Math.max(i - 1, 0));
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [active, items.length]);

  // Helper to generate correct image paths from a base filename
  const getImagePath = (src, size) => {
    const filename = src.substring(src.lastIndexOf('/') + 1).replace(/\.[^/.]+$/, '');
    return `/images/processed/projects/${filename}-${size}`;
  };

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((it, idx) => {
          const imgSrc = it.img || it.src;
          if (!imgSrc) return null;
          return (
            <div key={idx} className="card overflow-hidden">
              <button
                onClick={() => {
                  setActive(it);
                  setActiveIdx(idx);
                }}
                className="relative block w-full"
              >
                <picture>
                  <source
                    srcSet={`${imgSrc.replace(/\.(jpg|jpeg|JPG)$/, '.webp')} 1x`}
                    type="image/webp"
                  />
                  <img
                    loading="lazy"
                    src={imgSrc}
                    alt={`${it.title} - ${it.category} Project in ${
                      it.location || 'Tamil Nadu'
                    } by Sri GDM Interior Industries`}
                    className="w-full h-[300px] object-cover"
                    style={{ maxHeight: '300px' }}
                  />
                </picture>
                <div className="absolute left-0 bottom-0 right-0 p-4 bg-gradient-to-t from-black/40 to-transparent text-white">
                  {it.caption || 'Project'}
                </div>
              </button>
            </div>
          );
        })}
      </div>

      {active && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
          role="dialog"
          aria-modal="true"
        >
          <div className="bg-white rounded shadow max-w-4xl w-full p-4">
            <div className="flex gap-3 items-start">
              <button onClick={() => setActiveIdx((i) => Math.max(i - 1, 0))} aria-label="Previous">
                ‹
              </button>
              <div className="flex-1">
                {/* show higher-res preview in lightbox */}
                <picture>
                  <source
                    srcSet={items[activeIdx].img.replace(/\.(jpg|jpeg|JPG)$/, '.webp')}
                    type="image/webp"
                  />
                  <img
                    src={items[activeIdx].img}
                    alt={`${items[activeIdx].title} - Interior Design Project in ${
                      items[activeIdx].location || 'Tamil Nadu'
                    }`}
                    className="w-full max-h-[80vh] object-contain mx-auto"
                    style={{ maxWidth: '1200px' }}
                  />
                </picture>
                <p className="mt-2 text-sm text-muted">{items[activeIdx].caption}</p>
              </div>
              <button
                onClick={() => setActiveIdx((i) => Math.min(i + 1, items.length - 1))}
                aria-label="Next"
              >
                ›
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
